import { format } from 'date-fns'

export const parseMetricsDate = (date) => {
  if (!date) return new Date()

  const [year, month, day] = String(date).split('-').map(Number)
  if ([year, month, day].every(Number.isFinite)) {
    // Use local noon so YYYY-MM-DD keys render as the same calendar day for users in any timezone.
    return new Date(year, month - 1, day, 12)
  }

  return new Date(date)
}

export const formatDate = (date = undefined) => {
  if (date) return format(parseMetricsDate(date), 'MM/dd/yyyy')
  return format(new Date(), 'MM/dd/yyyy')
}

export const colors = ["#56042C", "#1077C3", "#FEC310", "#49BCE3"]
